import { render, staticRenderFns } from "./RevivedNumbersForm.vue?vue&type=template&id=10985573&scoped=true&lang=pug&"
import script from "./RevivedNumbersForm.vue?vue&type=script&lang=js&"
export * from "./RevivedNumbersForm.vue?vue&type=script&lang=js&"
import style0 from "./RevivedNumbersForm.vue?vue&type=style&index=0&id=10985573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10985573",
  null
  
)

export default component.exports